import isEmpty from 'lodash/isEmpty';
import { useCallback } from 'react';
import { useSelectUser } from '../../../../redux/User/selectors';
import { useWIRDraftComment } from '../../../../redux/WellGuardian/selectors';
import { WIRComment } from 'types/wellGuardian';

export const useAppendDraftComment = () => {
  const user = useSelectUser();
  const draftComment = useWIRDraftComment();
  const userName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();

  // Append draft comment to be saved
  const appendDraftComment = useCallback(
    (comments: WIRComment[]) => {
      return !isEmpty(draftComment)
        ? [
            ...comments,
            {
              commentText: encodeURIComponent(draftComment),
              dateLastUpdated: new Date().toISOString(),
              userAuthor: userName,
            },
          ]
        : comments;
    },

    [draftComment, userName],
  );

  return {
    appendDraftComment,
  };
};
